import React from "react";

/**
 * ErrorBoundary — catches runtime errors in any child component tree.
 * Without this, a single JS error causes the entire page to go blank.
 * Wrap sections individually for granular fault isolation.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // In production you'd send this to a monitoring service (e.g. Sentry)
    console.error("[ErrorBoundary]", error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            padding: "2rem",
            textAlign: "center",
            color: "var(--secondary-color, #888)",
            fontSize: "0.9rem",
          }}
        >
          Something went wrong loading this section.
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
